import React, { useState, useEffect } from 'react';
import Icon from 'icon';
import { Link, navigate } from 'gatsby';
import Img from 'shared/img';
import { formatDate } from 'utils/helpers';
import subcategories from 'data/subcategories.json';
import Nav from './nav';
import data, { hasException, exceptions } from '../data';
import s from './header.module.scss';
import ScrollDirection from './scroll-direction';

export default function Header() {
  const { social } = data;
  const [isNavVisible, setIsNavVisible] = useState(true);
  const [lazy, setLazy] = useState(false);
  const [hover, setHover] = useState('');
  const [display, setDisplay] = useState(false);
  const [direction, setDirection] = useState(null);
  const [viewItems, setViewItems] = useState({});
  useEffect(() => {
    if (hover) {
      clearTimeout(window.displayTimeout);
      setDisplay(true);
    } else {
      window.displayTimeout = setTimeout(() => setDisplay(false), 300);
    }
  }, [hover]);

  useEffect(() => {
    if (hasException(exceptions)) {
      setIsNavVisible(false);
    }
  }, []);

  const pages = data.pages.map(page => {
    const obj = { ...page };
    obj.hoverHandler = () => {
      setHover(page.text);
      setViewItems({ ...subcategories[page.text.toLowerCase()] });
    };
    return obj;
  });

  const hoverOut = () => {
    clearTimeout(window.displayTimeout);
    window.displayTimeout = setTimeout(() => setHover(''), 200);
  };

  const handleClick = () => {
    setHover('');
  };

  const [active, setActive] = useState(null);
  const handleNav = () => setActive(!active);

  const showSubcategories = hover && subcategories[hover.toLowerCase()];
  const isUpOrDown = direction !== null;
  const isUp = isUpOrDown && direction === 'up';

  const handleLazy = () => {
    if (window.innerWidth > 1229 && !lazy) {
      setLazy(true);
    }
  };
  return (
    <header
      onMouseEnter={() => handleLazy()}
      className={`${s.header} ${isUp ? s.up : ''} ${
        isUpOrDown && !isUp ? s.down : ''
        }`}
    >
      <ScrollDirection setDirection={setDirection} />
      <div className={s.innerWrapper}>
        <div className="container">
          <div className={s.wrapper}>
            <div className={s.logoWrapper} onClick={() => !hasException(exceptions) ? navigate('/') : location.pathname = '/'}>
              <Icon
                className={s.logo}
                icon="furlough-logo"
                alt="furlough logo"
              />
            </div>
            {
              isNavVisible ? (
                <Nav
                  {...{ pages, active, handleNav, hoverOut, lazy }}
                  categories={subcategories}
                />
              ) :
              ''
            }
            <div className={s.block}>
              {/* <div className={s.searchWrapper}>
              <Search idx="0" />
            </div> */}
              <div className={s.burgerWrapper} onClick={() => handleNav()}>
                <Icon icon="menu" />
              </div>
            </div>
            <ul className={s.socialWrapper}>
              {social.map(({ icon, href }, i) => (
                <li className={s.listItem} key={`${icon}-${i}`}>
                  <a className={s.socialIconWrapper} href={href}>
                    <Icon icon={icon} />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {lazy && (
        <div
          className={`${s.subcategoriesContainer} ${
            showSubcategories ? s.show : ''
            }`}
        >
          <div
            className={`${s.subcategoriesWrapper} ${display ? s.active : ''}`}
            onMouseLeave={hoverOut}
          >
            <ul
              className={
                showSubcategories?.subcategories?.length === 0 ? s.hideUL : ''
              }
            >
              {showSubcategories &&
                subcategories[hover.toLowerCase()].subcategories.map(item => (
                  <li
                    key={item.name}
                    onMouseEnter={() => {
                      setViewItems(item);
                    }}
                    onClick={() => handleClick()}
                  >
                    <Link
                      className={`${s.link} ${s[hover.toLowerCase()]} `}
                      to={`/${item.link}`}
                    >
                      <div dangerouslySetInnerHTML={{ __html: item.name }} />
                    </Link>
                  </li>
                ))}
            </ul>
            <div className={s.blogsWrapper}>
              <div
                className={`${s.title} ${
                  showSubcategories?.subcategories?.length === 0
                    ? s.fullwidth
                    : ''
                  }`}
                onClick={() => handleClick()}
              >
                <h2 dangerouslySetInnerHTML={{ __html: viewItems.name }} />
                <Link className={`${s.link}`} to={`/${viewItems.link || 'latest'}`}>
                  SEE ALL
                </Link>
              </div>
              <div
                className={`${s.newsWrapper} ${
                  showSubcategories?.subcategories?.length === 0
                    ? s.fullwidth
                    : ''
                  }`}
              >
                {viewItems.posts &&
                  viewItems.posts.slice(0, 4).map(news => (
                    <Link
                      onClick={() => handleClick()}
                      to={`/${news.link}`}
                      className={s.newsCard}
                      key={news.link}
                    >
                      <div className={s.newImg}>
                        <Img src={news.image || 'placeholder-dark'} effect />
                      </div>
                      {/* <div className={s.date}>{formatDate(news.date)}</div> */}
                      <div
                        className={s.newTitle}
                        dangerouslySetInnerHTML={{ __html: news.title }}
                      />
                      <p className={`${s.textWrapper}`}>
                        <span className={s.textBlock}>
                          <Icon className={s.icon} icon="user" />
                          <span className={s.metaText}>Furlough Team</span>
                        </span>
                        <span className={s.separator}>|</span>
                        <span className={s.textBlock}>
                          <Icon className={s.icon} icon="clock" />
                          <span className={s.metaText}>
                            {formatDate(news.date)}
                          </span>
                        </span>
                      </p>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
